var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      attrs: {
        title:
          (_vm.mode === "add" ? "Add" : "Edit") + " favorite - " + _vm.sipUri,
        closable: "",
      },
    },
    [
      _c(
        "ui-form",
        {
          attrs: { valid: _vm.formValid },
          on: {
            "update:valid": function ($event) {
              _vm.formValid = $event
            },
            submit: function ($event) {
              return _vm.update(
                _vm.sipUri,
                Object.assign(
                  {},
                  { name: _vm.contactTitle },
                  _vm.pinCode && { dtmf: _vm.pinCode },
                  _vm.pinCode && _vm.pinDelay && { dtmf_delay: _vm.pinDelay },
                  { favorite: true }
                )
              )
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "ui-dialog__content__body" },
            [
              _c("ui-input", {
                attrs: { label: "Favorite title" },
                model: {
                  value: _vm.contactTitle,
                  callback: function ($$v) {
                    _vm.contactTitle = $$v
                  },
                  expression: "contactTitle",
                },
              }),
              _vm._v(" "),
              _c("pin-input", {
                staticClass: "ui-dialog__content__body__pin-input",
                attrs: { "pin-delay": _vm.pinDelay },
                on: {
                  "update:pinDelay": function ($event) {
                    _vm.pinDelay = $event
                  },
                  "update:pin-delay": function ($event) {
                    _vm.pinDelay = $event
                  },
                },
                model: {
                  value: _vm.pinCode,
                  callback: function ($$v) {
                    _vm.pinCode = $$v
                  },
                  expression: "pinCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ui-dialog-footer",
            [
              _vm.mode === "edit"
                ? _c("ui-button", {
                    attrs: {
                      disabled: _vm.isFetching,
                      secondary: "",
                      text: "Remove",
                      tooltip: "Remove favorite",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.remove(_vm.sipUri)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ui-button", {
                attrs: {
                  disabled: _vm.isFetching || !_vm.formValid,
                  text: _vm.mode === "add" ? "Add" : "Update",
                  tooltip:
                    _vm.mode === "add" ? "Add favorite" : "Update favorite",
                  primary: "",
                  type: "submit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }